import { InputHTMLAttributes, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Eye, EyeOff } from 'lucide-react';

import { theme } from 'theme';
import TextInput from '@components/fields/input';
import TouchableOpacity from '@components/buttons/TouchableOpacity';

const ToggleButton = styled(TouchableOpacity)`
  flex-shrink: 0;

  &:hover:not(:disabled) {
    opacity: 0.8;
  }

  &:focus {
    outline: none;
  }
`;

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  errorText?: string;
};

const PasswordInput = ({ ...props }: Props) => {
  const [showPassword, setShowPassword] = useState(false);
  const inputType = useMemo(
    () => (showPassword ? 'text' : 'password'),
    [showPassword],
  );

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleButton = (
    <ToggleButton
      type='button'
      onClick={togglePasswordVisibility}
      tabIndex={-1}
      disabled={props.disabled}
    >
      {showPassword ? (
        <EyeOff size={16} color={theme.colors.grey[400]} />
      ) : (
        <Eye size={16} color={theme.colors.grey[400]} />
      )}
    </ToggleButton>
  );

  return <TextInput type={inputType} {...props} customIcon={toggleButton} />;
};

export default PasswordInput;
